import {
  getMyAcls,
  getRecordsIAmAuthorizedOn,
  addAcl,
  getMyMessages,
  setupNewConversation,
  getMessageProto,
  sendMessage,
  associateRecord,
  deleteSingleMessage,
  revokeAuth,
  changeDelegateStatus
} from "../api";
export const actions = {
  addNotification({ commit }, notification) {
    commit("PUSH_NOTIFICATION", notification);
    // setTimeout(function() {
    //   commit('REMOVE_NOTIFICATION', notification);
    // }, 5000);
  },
  removeNotification({ commit }, notification) {
    commit("REMOVE_NOTIFICATION", notification);
  },
  createErrorMessage({ commit }, error) {
    commit("CREATE_ERROR_MESSAGE", error);
  },

  //acls
  addDelegate({ commit }, newAclObj) {
    return addAcl(newAclObj);
  },
  async getMyAcls({ commit }, username) {
    const acls = await getMyAcls(username);
    commit("SET_MY_ACLS", acls);
    return acls;
  },
  async getAcls({ commit }, username) {
    const acls = await getMyAcls(username);
    commit("SET_ACLS", acls);
    return acls;
  },

  async getRecordsIAmAuthorizedOn({ commit }) {
    const recordsIAmAuthorizedOn = await getRecordsIAmAuthorizedOn();
    commit("SET_RECORDS_I_AM_AUTHORIZED_ON", recordsIAmAuthorizedOn.accounts);
    return recordsIAmAuthorizedOn;
  },
  removeAuthOnUser({ commit }, remauthobj) {
    return revokeAuth(remauthobj);
  },
  changeDelegateStatus({ commit }, delegateStatusObj) {
    return changeDelegateStatus(delegateStatusObj);
  },
  //MESSAGING
  getMessages({ commit }, username) {
    return getMyMessages(username);
  },
  newConversation({ commit }, newConvoObj) {
    return setupNewConversation(newConvoObj);
  },
  getMessageProto({ commit }, message) {
    return getMessageProto(message);
  },
  sendMessage({ commit }, message) {
    return sendMessage(message);
  },
  deleteSingleMessage({ commit }, data) {
    return deleteSingleMessage(data);
  },
  //USER
  associateRecord({ commit }, associateRecordObject) {
    return associateRecord(associateRecordObject);
  }
};
